import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

import { useEffect, useState } from 'react'

const ReorderData = ({ visible, onClose, data, onSave }) => {
  const [localData, setLocalData] = useState([...data])
  const handleDrag = (e, index) => {
    e.dataTransfer.setData('index', index)
  }

  useEffect(() => {
    setLocalData(data)
  }, [data])

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData('index')
    const updated = [...localData]
    const [removed] = updated.splice(dragIndex, 1)
    updated.splice(dropIndex, 0, removed)
    setLocalData(updated)
  }

  const handleSave = () => {
    onSave(localData)
    onClose()
  }

  return (
    <CModal visible={visible} onClose={onClose} className="patient-theme-modal">
      <CModalHeader onClose={onClose}>
        <CModalTitle>Re-order</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {localData.map((item, index) => (
          <div
            key={item.id}
            draggable
            onDragStart={(e) => handleDrag(e, index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, index)}
            className="p-2 border rounded mb-2 pe-reorder-item"
          >
            {item.name}
          </div>
        ))}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose} className="ui-action-btn ui-action-btn--secondary">
          Cancel
        </CButton>
        <CButton color="primary" onClick={handleSave} className="ui-action-btn ui-action-btn--primary">
          Save Order
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ReorderData
